import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import CheckBox from "@components/CheckBox/CheckBox";
import Sites from "src/constants/Sites";
import { getUTMParams, doubleOptinParkingList } from "helpers/Helper";

import styles from "./NewsLetters2.module.css";

const NewsLetter2Card = forwardRef((props, ref) => {
  const {
    lists = [],
    userOptionalParams = {},
    logo = "",
    content = "",
    cardText = "",
    optInNewsletter,
    optInText = "",
    shouldSendEmail = true,
    parent_siteid,
    site_id,
    site,
    disclaimerText,
  } = props;

  const [isOptIn, setIsOptIn] = useState(
    site_id === Sites.EARLYBIRDBOOKS ? true : false
  );

  useImperativeHandle(ref, () => ({
    getValue,
    isOptedIn,
  }));

  const formatLists = () => {
    if (lists && lists.length) {
      let updatedLists = {};
      lists.forEach((name) => {
        updatedLists[name] = 1;
      });
      return updatedLists;
    }
  };

  const isOptedIn = () => {
    return isOptIn;
  };

  const getValue = () => {
    // if current/parent site id matches NL site_id, sign them up for it by default
    if (parent_siteid == site_id || isOptIn) {
      let values = {};
      let updatedOptionalParams = userOptionalParams;
      const queryString = window.location.search;
      const utmParams = getUTMParams(queryString);

      if (parent_siteid === site_id && utmParams) {
        const vars = updatedOptionalParams?.vars;
        vars.referral_source = utmParams.referral_source || "";
        updatedOptionalParams.vars = vars;
      }

      if (updatedOptionalParams?.vars?.referral_source === "") {
        delete updatedOptionalParams.vars.referral_source;
      }

      const lists = formatLists();
      if (lists) {
        updatedOptionalParams.lists = lists;
      }
      //For EBB, don't send welcome email due to double opt-in workflow
      if (
        site_id == Sites.EARLYBIRDBOOKS &&
        parent_siteid !== Sites.EARLYBIRDBOOKS
      ) {
        values.shouldSendEmail = false;
        let parkingList = {};
        const parkingName = doubleOptinParkingList()[site].name;
        parkingList[parkingName] = parkingName;
        updatedOptionalParams.lists = parkingList;
      } else {
        values.shouldSendEmail = shouldSendEmail;
      }

      values.name = site;
      values.userOptionalParams = {
        ...updatedOptionalParams,
        ...userOptionalParams,
      };
      return values;
    }
  };

  const handleCheckboxChange = (e) => {
    setIsOptIn(e.target.checked);
  };

  if (parent_siteid === site_id) {
    return null;
  }

  const optInRef = useRef();
  return (
    <div className={[styles["newsletter-card"]]}>
      <img alt="The Reader" src={logo} />
      <p>{cardText}</p>
      <label className="control control--checkbox">
        <CheckBox
          ref={optInRef}
          isChecked={isOptIn}
          onChange={handleCheckboxChange}
          value={optInNewsletter}
          label={optInText}
        />
      </label>
      {disclaimerText && (
        <>
          <span className={styles["card-footer-text"]}>{disclaimerText}</span>
          <div className="control__indicator"></div>
        </>
      )}
    </div>
  );
});

export default NewsLetter2Card;
